import { registerAuditLabels } from "@vixio/ui";
import type { HelpBundle, HelpSearchResult } from "@vixio/ui";

/** Tipos das linhas e RPCs do módulo help (ver modules/help/README.md). */

export interface TopicView {
  id: string;
  org_id: string | null;
  module: string;
  key: string;
  locale: string;
  routes: string[];
  category: string | null;
  tags: string[];
  status: "draft" | "published" | "archived";
  published_version_id: string | null;
  published_version: number | null;
  latest_version_id: string | null;
  latest_version: number | null;
  title: string | null;
  summary: string | null;
  body_md: string | null;
  has_unpublished_changes: boolean;
  helpful_yes: number;
  helpful_no: number;
  updated_at: string;
}
export interface FieldHint { id: string; org_id: string | null; module: string; entity: string; field: string; short_tip: string; placeholder: string | null; error_hint: string | null; topic_key: string | null }
export interface Tour { id: string; org_id: string | null; key: string; module: string; route: string; title: string; steps: Array<{ anchor?: string; title: string; body: string }>; min_role: string; active: boolean; version: number }
export interface Term { id: string; org_id: string | null; term: string; definition_md: string; synonyms: string[]; module: string | null }
export interface Faq { id: string; org_id: string | null; module: string; question: string; answer_md: string; position: number; published: boolean }

export type SearchRow = HelpSearchResult & { module: string | null; rank: number };

declare module "@vixio/data" {
  interface RpcRegistry {
    "help.get_bundle": { args: { p_org: string; p_route: string; p_module?: string | null }; returns: HelpBundle };
    "help.search": { args: { p_org: string; p_q: string; p_limit?: number }; returns: SearchRow[] };
    "help.record_feedback": { args: { p_org: string; p_topic: string; p_helpful: boolean; p_comment?: string | null; p_route?: string | null }; returns: string };
    "help.upsert_topic": {
      args: {
        p_org: string | null;
        p_module: string;
        p_key: string;
        p_title: string;
        p_body_md: string;
        p_routes?: string[];
        p_summary?: string | null;
        p_category?: string | null;
        p_tags?: string[];
        p_publish?: boolean;
        p_change_note?: string | null;
      };
      returns: string;
    };
    "help.publish_topic": { args: { p_topic: string; p_version?: number | null }; returns: null };
    "help.archive_topic": { args: { p_topic: string }; returns: null };
    "help.upsert_hint": { args: { p_org: string | null; p_module: string; p_entity: string; p_field: string; p_short_tip: string; p_placeholder?: string | null; p_error_hint?: string | null; p_topic_key?: string | null }; returns: string };
    "help.delete_hint": { args: { p_id: string }; returns: null };
    "help.upsert_tour": { args: { p_org: string | null; p_key: string; p_module: string; p_route: string; p_title: string; p_steps: Tour["steps"]; p_active?: boolean; p_min_role?: string }; returns: string };
    "help.upsert_term": { args: { p_org: string | null; p_term: string; p_definition_md: string; p_synonyms?: string[]; p_related_keys?: string[]; p_module?: string | null; p_id?: string | null }; returns: string };
    "help.delete_term": { args: { p_id: string }; returns: null };
    "help.upsert_faq": { args: { p_org: string | null; p_module: string; p_question: string; p_answer_md: string; p_position?: number; p_published?: boolean; p_id?: string | null }; returns: string };
    "help.delete_faq": { args: { p_id: string }; returns: null };
  }
}

registerAuditLabels({
  "help_topic.saved": "Tópico de ajuda salvo",
  "help_topic.published": "Tópico de ajuda publicado",
  "help_topic.archived": "Tópico de ajuda arquivado",
  "help_hint.saved": "Dica de campo salva",
  "help_hint.deleted": "Dica de campo removida",
  "help_tour.saved": "Tour salvo",
  "help_term.saved": "Termo do glossário salvo",
  "help_term.deleted": "Termo do glossário removido",
  "help_faq.saved": "Pergunta da ajuda salva",
  "help_faq.deleted": "Pergunta da ajuda removida",
});
